module.exports = __webpack_public_path__ + "static/img/athome_waxing.4685332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/athome_waxing.png
// module id = 750
// module chunks = 1